import React, {Component} from 'react';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';
import {getBackgroundColor} from '../../../utils/drag-and-drop';

export const IsDraggingContext = React.createContext(false);

class DragDropTableBody extends Component {
    constructor(props) {
        super(props);
        this.state = {isDragging: false};
        this.handleDrop = this.handleDrop.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    handleDrop(droppedItem) {
        this.setState({
            isDragging: false,
        });
        // Ignore drop outside droppable container
        if (!droppedItem.destination) {
            return;
        }
        this.props.move(droppedItem.source.index, droppedItem.destination.index);
    }

    handleDrag() {
        this.setState({
            isDragging: true,
        });
    }


    render() {
        const {children} = this.props;

        return (
            <IsDraggingContext.Provider value={this.state.isDragging}>
                <DragDropContext onDragEnd={this.handleDrop} onBeforeDragStart={this.handleDrag}>
                    <Droppable droppableId="items-container">
                        {(provided, snapshot) => (
                            <tbody
                                className="questions-container"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{background: getBackgroundColor(snapshot)}}
                            >
                                {children}
                                {provided.placeholder}
                            </tbody>
                        )}
                    </Droppable>
                </DragDropContext>
            </IsDraggingContext.Provider>
        );
    }
}

export default DragDropTableBody;
